import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import type { UserTenantFragment } from "@/v2-backoffice-client/user/tenant/__types__/user.tenant.fragment"
import { useUserTenantQuery } from "@/v2-backoffice-client/user/tenant/user.tenant.query"
import UserTenantManageDialog from "@/v2-backoffice-client/user/tenant/manage/UserTenantManageDialog"
import { formatUserName } from "@/v2-backoffice-client/user/user.utils"

export type UserTenantManageMenuItemProps = ActionMenuItemProps & {
  user: UserFragment
  existingUserTenants?: UserTenantFragment[]
}

function UserTenantManageMenuItem(props: UserTenantManageMenuItemProps) {
  const { user, existingUserTenants, onSelect, ...actionMenuItemProps } = props

  const [isOpen, setIsOpen] = useState(false)

  const { data } = useUserTenantQuery({
    variables: { userId: user.Id, onlyDeleted: false },
    skip: !isOpen || existingUserTenants !== undefined,
  })

  const resolvedUserTenants =
    existingUserTenants ?? data?.getUserTenantsByUserId ?? []

  return (
    <>
      <ActionMenu.Item
        iconSrc="user-gear"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
          onSelect?.(e)
        }}
        {...actionMenuItemProps}
      >
        Manage Teams
      </ActionMenu.Item>

      <UserTenantManageDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        userId={user.Id}
        userName={formatUserName(user?.FirstName, user?.LastName)}
        existingUserTenants={resolvedUserTenants}
      />
    </>
  )
}

export default UserTenantManageMenuItem
